import { API_BASE_URL } from 'redux/constants'

const appConfig = {
    apiPrefix: API_BASE_URL,
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '',
    enableMock: false
}

export default appConfig